export default from './MortgageBalanceQuestion';



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/MortgageBalanceQuestion/index.js